import { Injectable } from "@angular/core";
import { RestService } from "../../../services/rest.service";

@Injectable({
  providedIn: 'root'
})
export class ProfileVerificationMasterApi {
  public static readonly ApiEndpoint = 'master/profile-verification'

  constructor(private restService: RestService) {
  }

  /**
   * Triggers profile verification check for a given user.
   * @param userId The user ID to run profile verification check for.
   */
  runCheck(userId: string) {
    return this.restService.send<any>({
      url: `${ProfileVerificationMasterApi.ApiEndpoint}/run-check/${userId}`,
      method: 'GET'
    });
  }
}
